module.exports = {
    charities: [
        {
            id: 1,
            title : 'Help For School',
            category : 'Money',
            thumbnail : 'https://a57.foxnews.com/static.foxnews.com/foxnews.com/content/uploads/2021/04/931/524/Generic-Classroom.jpg?ve=1&tl=1',
            pledged: 99000,
            target: 100000,
            date_end: +new Date('20 February 2022'),
            profile_photo: 'https://www.seekpng.com/png/detail/60-604032_face-businessman-png-dummy-images-for-testimonials.png',
            profile_name: 'Paulo Julio',
            no_pledges: 0
        },
        {
            id: 2,
            title : 'Help For School',
            category : 'Money',
            thumbnail : 'https://a57.foxnews.com/static.foxnews.com/foxnews.com/content/uploads/2021/04/931/524/Generic-Classroom.jpg?ve=1&tl=1',
            pledged: 2000,
            target: 50000,
            date_end: +new Date('20 February 2022'),
            profile_photo: 'https://www.seekpng.com/png/detail/60-604032_face-businessman-png-dummy-images-for-testimonials.png',
            profile_name: 'Paulo Julio',
            no_pledges: 0
        }
    ]
}